
import { ReelStopPresentation } from "../normal/ReelStopPresentation";
import { PunkParsedGameData } from "../../../server/data/PunkParsedGameData";
import { StateHandler } from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import { JumpingWildController, JumpWildState } from "../../independent/jumpingWild/JumpingWildController";
import { PosterManager, PosterStates } from "../../independent/Poster/PosterManager";
import { SoundConfig } from "../../../SoundConfig";
import { PunkGameModuleConfig } from "../../../PunkGameModuleConfig";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { ReelAnimationManager } from "../../independent/reelAnimator/ReelAnimationManager";
import { ReelItemOverlay } from "../../independent/overlay/ReelItemOverlay";
import { TrainState } from "../../independent/countup/XWaysCounter";
import { PunkParsedInitData } from "../../../server/data/PunkParsedInitData";
import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import { ReelAnimationState } from "../../independent/reelAnimator/ReelAnimationController";
import { WinCounter } from "../../independent/countup/WinCounter";
import { TweenMax } from "gsap";
import { PunkBackground } from "../../../background/PunkBackground";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { PunkEngineManager } from "../../../punkEngine/PunkEngineManager";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { ReelSymbolStates } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { ReelSymbolName } from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";

export class FeatureStopState extends StateHandler {
    public static readonly RANDOM_INTRO:string = "random_intro";
    public static readonly SKULLS:string = "skulls";

    public static readonly RESTORE:string = "restore";

    public static readonly RESPIN:string = GameMode.RESPIN;
    public static readonly JUMP:string = "jump";
    public static readonly TRAINSTOPS:string = "trainstops";
    public static readonly TRAINENTER:string = "trainenter";
    public static readonly FEATURES:string = "features";
    public static readonly DODARK:string = "dodark";
    public static readonly REMDARK:string = "remdark";
    public static readonly DEDARK:string = "dedark";
    public static readonly STOP:string = "stop";
    public static readonly DONE:string = "done";
}

export class FeatureReelStopPresentation extends ReelStopPresentation {

    protected _bonusState:FeatureStopState = new FeatureStopState(FeatureStopState.STOP);
    protected jumpWReelPos:number[];
    protected isFreeSpin: boolean = false;

    protected fIndex:number = 0;
    protected featureWon:string[];

    protected restored:boolean = false;
    protected jwBefore:number = 0;

    protected fsUpdate:number = 0;
    protected isIntro:boolean = false;

    protected speedActive:boolean = false;
    protected fsLeft:number = 0;

    protected xTraReelPos:number = -1;
    protected xtraReelTriggered:boolean = false;
    protected willGetXtraJW:boolean = false;

    public checkForActivation(data:PunkParsedGameData):boolean { return data.mode != GameMode.NORMAL; }

    public setParsedInitData(data:PunkParsedInitData){
        this.restored = data.isRestoreState && data.nextMode == GameMode.FREESPIN;
        for(let s:number = 0; s < data.scatterReelPositions.length; s++) if(data.scatterReelPositions[s] >= 0)  this.restored  = false;
    }
        
    public setParsedGamedData(data:PunkParsedGameData):void {
        if(this._gameData) return;
        super.setParsedGamedData(data);
        this._bonusState.set(this._jumpPositions.length != 0 ? FeatureStopState.TRAINENTER : FeatureStopState.STOP);

        if(this.restored){
            this._bonusState.set(FeatureStopState.RESTORE);
        }

        this.fsLeft = data.freespinsLeft;
        this.speedActive = false;
        this.fIndex = 0;
        this.featureWon = data.freespinTrain;
        this.fsUpdate = data.freespinsLeft;
        this.jwBefore = this._jumpPositions.length;

        this.willGetXtraJW = false;
        this.xtraReelTriggered = false;
        this.xTraReelPos = this._jumpPositions.length > 0 ? this._jumpPositions[this._jumpPositions.length-1].to.x : -1;


        this.jumpWReelPos = [];
        for(let jw:number = 0; jw < this.jwBefore;jw++){
            if(this.jumpWReelPos.indexOf(this._jumpPositions[jw].to.x) == -1) this.jumpWReelPos.push(this._jumpPositions[jw].to.x);
        }

        for(let fW:number = 0; fW < this.featureWon.length; fW++){
            if(this.jumpWReelPos.indexOf(fW) == -1) continue;
            
            if(this.featureWon[fW][0] == "W"){
                this.jwBefore--;

                const lastJumpPos:number = this._jumpPositions[this._jumpPositions.length-1].to.x;
                let amountOfJWOnNewPos:number = 0;
                for(let jw:number = 0; jw < this._jumpPositions.length;jw++){
                    if(this._jumpPositions[jw].to.x == lastJumpPos) amountOfJWOnNewPos++;
                }

                if(amountOfJWOnNewPos == 1){
                    this.jumpWReelPos = this.jumpWReelPos.filter((value:number) => {return value != lastJumpPos;} )
                    this.willGetXtraJW = true;
                } 
            } 
            if(this.featureWon[fW][0] == "S"){
                const amount:number = parseFloat(this.featureWon[fW][this.featureWon[fW].length-1]);
                this.fsUpdate -= amount;
            } 
        }
        this.jumpWReelPos.sort();
    }

    public getPresentation():void{
        if(PunkEngineManager.isQuickStop && !this.speedActive){
            this.speedActive = true;
            TweenMax.globalTimeScale(20);
        } 

        switch(this._bonusState.state){
            case FeatureStopState.RESTORE:
                this.restoring();
                break;
            case FeatureStopState.TRAINENTER:
                this.trainArrives();
                this.jumpTheWilds();
                this._bonusState.set(FeatureStopState.DODARK);
                break;
            case FeatureStopState.DODARK:
                this.doDark(1);
                this._bonusState.set(FeatureStopState.TRAINSTOPS);
                break;
            case FeatureStopState.TRAINSTOPS:
                this.trainStops();
                this._bonusState.set(FeatureStopState.REMDARK);
                break;
            case FeatureStopState.REMDARK:
                this.removeNonHits(0.5);
                this._bonusState.set(FeatureStopState.FEATURES);
                break;
            case FeatureStopState.FEATURES:
                const pos:number = this.xtraReelTriggered ? this.xTraReelPos : this.jumpWReelPos[this.fIndex];
                this.presentFeatureWon(pos);
                if(this.fIndex == this.jumpWReelPos.length && !this.xtraReelTriggered) this._bonusState.set(FeatureStopState.DEDARK);
                break;
            case FeatureStopState.DEDARK:
                TweenMax.globalTimeScale(1);
                this.deDark();
                this._bonusState.set(FeatureStopState.STOP);
                break;
            default:
                TweenMax.globalTimeScale(1);
                super.getPresentation();
                break;
        }
        if(this._animationTimeline && this._animationTimeline.isActive()) this.pTimeline.delay(this._animationTimeline.totalDuration() - this._animationTimeline.totalTime())
    }

    protected restoring():void{
        if(this.restored){
            PunkGameModuleConfig.xWayCounter.setTrainItems(this.featureWon);
            ReelAnimationManager.bonusReel.NumberOfSkulls(this.jwBefore);
            this._animationTimeline.to(this,0.3,{});
            for(let r = 0; r < this.jwBefore;r++){
                this._animationTimeline.add(() => {
                    if(JumpingWildController.instance.items.length != this.jwBefore){
                        JumpingWildController.instance.createJumpWilds(this._jumpPositions[r].from.x,this._jumpPositions[r].from.y);
                        JumpingWildController.instance.StartShow();
                        this._animationTimeline.add(() => JumpingWildController.instance.ChangeToSpine(),0.3)
                    }
                });
            }

            SoundManager.playBonus();
            SoundManager.fadeAmbienceLoop(1,1);

            this._animationTimeline.add([
                () => ReelAnimationManager.bonusReel.killLoop(),
                () => ReelAnimationManager.bonusReel.removeSkulls(false),
                () => JumpingWildController.instance.StartShow(),
            ]);
            this._animationTimeline.add(() => PunkGameModuleConfig.xWayCounter.setVisible(false,0.2));
            this._animationTimeline.add(() => PunkBackground.instance.changeGraphicAlpha(0.3, 0.6));
            this._animationTimeline.to(this,0.3,{});

            this.restored = false;
            this._animationTimeline.add (() => this._bonusState.set(FeatureStopState.TRAINENTER));
        }
    }

    protected removeNonHits(duration:number = 0.5):void{
        const durationLeft:number = this._animationTimeline.totalDuration() - this._animationTimeline.totalTime();

        for(let reel:number = 0; reel < PunkEngineManager.AllReels.length; reel++){
            if(this.jumpWReelPos.indexOf(reel) >= 0){
                if(this.featureWon[reel] == "X1"){
                    this._animationTimeline.add([
                        () => ReelAnimationManager.getReelArea(reel).overlayGraphicAlpha(0,0.6,duration),
                        () => ReelAnimationManager.getReelArea(reel).showReelGlow(false)
                    ], durationLeft)
                } 
                else this._animationTimeline.add(PunkGameModuleConfig.xWayCounter.showGlowPositions([reel],true,duration), durationLeft);
            }  
        };
        this._animationTimeline.to(this,duration,{},durationLeft+duration);
    }

    protected doDark(duration:number = 1):void{
        for(let reel:number = 0; reel < PunkEngineManager.AllReels.length; reel++){
            if(this.jumpWReelPos.indexOf(reel) == -1) this._animationTimeline.add(() => ReelAnimationManager.getReelArea(reel).overlayGraphicAlpha(0,0.6, duration),0);
            else this._animationTimeline.add(() => ReelAnimationManager.getReelArea(reel).showReelGlow(true,duration),0);
        };
        this._animationTimeline.to(this,duration,{});
        // this._animationTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.TRAIN_BRAKE), "-=0.3");
    }

    protected presentFeatureWon(indx:number):void{

        this.xtraReelTriggered = false;

        const featureName:string = this.featureWon[indx];
        const featureType:string = featureName[0];

        const durr:number = 1;

        if(featureName != "X1"){
            for(let jw:number = 0; jw < this.jwBefore;jw++){
                if(this._jumpPositions[jw].to.x == indx){
                    JumpingWildController.instance.playJumpAttentionHit(jw);
                }
            }
            
            ReelAnimationManager.getReelArea(indx).showAnimation(ReelAnimationState.REEL_ELECTRIC);
            PunkGameModuleConfig.xWayCounter.playAttention(indx);
            PunkGameModuleConfig.xWayCounter.showGlowPositions([indx],false,durr);
            SoundManager.playSoundEffect(SoundConfig.instance.FS_LIGHTNING);
            this._animationTimeline.to(this,durr,{})
        } 

        switch(featureType){
            case "X": // Multiplier
                if(featureName != "X1"){
                    for(let jw:number = 0; jw < this.jwBefore;jw++){
                        if(this._jumpPositions[jw].to.x == indx){
                            this._animationTimeline.add([
                                () => JumpingWildController.instance.changeMultText(jw,featureName),
                                JumpingWildController.instance.PlayState(jw, JumpWildState.MERGE, true),
                            ],this._animationTimeline.totalTime())
                        }
                    }
                    this._animationTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.FS_MULTIPLIER_ADDED),this._animationTimeline.totalTime())
                }
                break;
            case "W": // JumpingWild
                this.addExtraWild(indx)
                break;
            case "F": // 6X6
                TweenMax.globalTimeScale(1);
                PunkEngineManager.RAll((reelID:number) => PunkEngineManager.getReel(reelID).isQuickStop = false);
                this.speedActive = true;
                this.showSpots();
                this._animationTimeline.to(this,durr,{});
                break;
            case "S": // Extra FS
                this.FSUpCounter(featureName);
                this._animationTimeline.to(this,durr*1.2,{});
                // Retrigger
                break;
            case "M": // ExpandingWild
                this.mysteryFlasher(indx, true);
                this._animationTimeline.to(this,durr,{})
                break;
        }

        this._animationTimeline.to(this,0.2,{});
        if(!this.xtraReelTriggered)
            this.fIndex++;
    }

    protected FSUpCounter(featureName:string):void{
        const start:number = this._animationTimeline.totalTime();
        const amount:number = parseFloat(featureName[featureName.length-1]);
        this.fsUpdate += amount;

        this._animationTimeline.add(() => PosterManager.instance.playFSRetrigger(PosterStates.RETRIGGER + "_"+ amount),start);
        this._animationTimeline.add(() => SlotGame.keypad.setZeroBetSpinCounter(this.fsUpdate),start+1*0.5);
    }

    protected addExtraWild(indx:number):void{
        const newJwId:number = this._jumpPositions.length-1;
        JumpingWildController.instance.createJumpWildsFS(indx, -1);
        this._animationTimeline.add(() => JumpingWildController.instance.ChangeToSpine(), 0)
        this._animationTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.WILD_MOVES),0);
        this._animationTimeline.add(() => this.jwBefore++ ,0)

        const timeTotDurr:number = this._animationTimeline.totalDuration();

        this._animationTimeline.add(
            JumpingWildController.instance.JumpTo({
            ID: newJwId,
            to:{reel: this._jumpPositions[newJwId].to.x,row: this._jumpPositions[newJwId].to.y},
            duration: MathHelper.frameToSeconds(20),
            state: JumpWildState.WIN
        }),timeTotDurr)

        if(this.willGetXtraJW){

            this.xTraReelPos = this._jumpPositions[this._jumpPositions.length-1].to.x;
            const featureName:string = this.featureWon[this.xTraReelPos];
            if(featureName == "X1") return;
            this.xtraReelTriggered = true;
            
            this._animationTimeline.add([
                () => ReelAnimationManager.getReelArea(this.xTraReelPos).overlayGraphicAlpha(0.6,0,0.2),
                () => ReelAnimationManager.getReelArea(this.xTraReelPos).showReelGlow(true),
                () => PunkGameModuleConfig.xWayCounter.showGlowPositions([this.xTraReelPos],true,0.5),
                () => PunkGameModuleConfig.xWayCounter.showTrainItems(true, this.jumpWReelPos.concat([this.xTraReelPos]), 0.3)
            ],timeTotDurr+MathHelper.frameToSeconds(20))
            this._animationTimeline.to(this,0.3,{},MathHelper.frameToSeconds(20));
        }else{
            const featureName:string = this.featureWon[this._jumpPositions[newJwId].to.x];
            if(featureName == "X1" || featureName[0] != "X") return;
            this._animationTimeline.add([
                () => JumpingWildController.instance.changeMultText(newJwId,featureName),
                () => JumpingWildController.instance.PlayState(newJwId, JumpWildState.MERGE, true)
            ],timeTotDurr + MathHelper.frameToSeconds(20))
        }
    }

    protected showSpots():void{
        let totDurr:number = this._animationTimeline.totalDuration();
        const startDurr:number = 1;
        let animDurr:number = 0.3;

        this._animationTimeline.add(() => PosterManager.instance.playSirene(true, 0),totDurr);
        this._animationTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.SIREN),totDurr);
        this._animationTimeline.add(() => WinCounter.winWayCounter.showWaysCounter(startDurr),totDurr);
        this._animationTimeline.add(() => ReelItemOverlay.instance.fadeState(true,startDurr*0.75),totDurr);
        this._animationTimeline.add(() => ReelItemOverlay.instance.fadeState(false,startDurr*0.25),totDurr+startDurr*0.75);

        totDurr = totDurr+startDurr+0.5;
        const totalWaveDurr:number = animDurr*PunkEngineManager.AllReels.length-1 + animDurr;
        const delayBetween:number = 0.25;
        for(let times = 0; times < 3; times++){

            this._animationTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.COUNTER_6X6,1000000000),totDurr);
            this._animationTimeline.add(() => WinCounter.winWayCounter.countTowards(Math.pow(3+times,6),Math.pow(4+times,6),totalWaveDurr,times),totDurr);
            this._animationTimeline.add(() => SoundManager.stopSoundEffect(SoundConfig.instance.COUNTER_6X6),totDurr+totalWaveDurr);
            
            for(let reel = 0; reel < PunkEngineManager.AllReels.length; reel++){
                let reelDelay:number = reel*animDurr;
                this._animationTimeline.add(() => PunkEngineManager.getReel(reel).changeReelAmount(4+times),totDurr);
                this._animationTimeline.add(() => ReelItemOverlay.instance.fadeGlowState(reel,true,animDurr),totDurr + reelDelay*0.5);
                this._animationTimeline.add(() => ReelItemOverlay.instance.fadeGlowState(reel,false,animDurr),totDurr + animDurr + reelDelay);
            }

            totDurr += totalWaveDurr + delayBetween;
            if(times == 2){
                for(let r = 0; r < this._jumpPositions.length;r++){
                    this._animationTimeline.add([
                        () => JumpingWildController.instance.JumpTo({
                        ID:r,
                        to:{reel: this._jumpPositions[r].to.x,row: this._jumpPositions[r].to.y},
                        duration: MathHelper.frameToSeconds(20),
                        state: JumpWildState.WIN
                    })],totDurr + delayBetween)
                }
                this._animationTimeline.add(() => WinCounter.winWayCounter.waysHide(startDurr*0.5),totDurr + delayBetween);
                this._animationTimeline.add(() => {},totDurr + delayBetween + startDurr*0.5);
            }
        }

        this._animationTimeline.add([
            () => SoundManager.playSoundEffect(SoundConfig.instance.WILD_MOVES),
            () =>  PosterManager.instance.playSirene(false)
        ],totDurr + delayBetween);
    }

    protected playBounceAnimation(reelID:number):void{
        if(this._gameData == undefined) return;
        super.playBounceAnimation(reelID);

        for(let r = 0; r < this._jumpPositions.length;r++){
            if(reelID == this._jumpPositions[r].to.x){
                const pos:number = PunkEngineManager.getReel(reelID).Engine.reverse ? this._jumpPositions[r].to.y+1 : this._jumpPositions[r].to.y-1;
                this._animationTimeline.add([
                    PunkEngineManager.getReel(reelID).getSymbol(pos)!.changeState({
                    state: ReelSymbolStates.NORMAL,
                    duration: 0.4,
                    newSym: ReelSymbolName.WILD,
                    forceState:true,
                }),
                ],this._animationTimeline.totalTime());
            }
        }
        
        if(this._gameData.mode == GameMode.RESPIN && reelID == 5){
            SoundManager.fadeAmbienceLoop(0,1);
            SoundManager.stopAmbientLoop(SoundConfig.instance.RESPIN_MUSIC);
            SoundManager.playSoundEffect(SoundConfig.instance.RESPIN_END);
        }
    }

    protected mysteryFlasher(reelID:number,active:boolean):void{
        const takenSpots:number[] = [];
        for(let jw:number = 0; jw < this._jumpPositions.length;jw++){
            if(this._jumpPositions[jw].to.x == reelID){
                for(let row:number = 0; row < PunkEngineManager.getReel(reelID).AllWindowSymbols.length; row++){
                    if(this._jumpPositions[jw].to.y == row) takenSpots.push(row);
                }
            }
        }

        for(let sym:number = 0; sym < PunkEngineManager.getReel(reelID).AllWindowSymbols.length;sym++){
            if(takenSpots.indexOf(sym) >= 0) continue;
            ReelItemOverlay.instance.flashSymbol(reelID,sym,2, active);
        }
    }

    protected deDark():void{
        for(let reel:number = 0; reel < PunkEngineManager.AllReels.length; reel++){
            ReelAnimationManager.getReelArea(reel).overlayGraphicAlpha(0.6,0,0.2);
            ReelAnimationManager.getReelArea(reel).showReelGlow(false);
        };
        this._animationTimeline.to(this,0.3,{});
    }

    protected trainArrives():void{
        this._animationTimeline.add(() => PunkGameModuleConfig.xWayCounter.FreeSpinsCounter(0.4,false));
        this._animationTimeline.add(() => PunkGameModuleConfig.xWayCounter.trainState(TrainState.INTRO),this._animationTimeline.totalDuration() + 0.2);
        this._animationTimeline.add(() => PunkGameModuleConfig.xWayCounter.trainLoop(true), this._animationTimeline.totalDuration() +  TrainState.getDuration(TrainState.INTRO));
        this._animationTimeline.add(() => PunkGameModuleConfig.xWayCounter.counterActive(false));
    }

    protected trainStops():void{

        PunkGameModuleConfig.xWayCounter.UpdateFreeSpinCounter(this.fsLeft-1);

        const durationLeft:number = this._animationTimeline.totalDuration() + PunkGameModuleConfig.xWayCounter.timeLeftInLoop();
        this._animationTimeline.add(() => PunkGameModuleConfig.xWayCounter.trainLoop(false),durationLeft);
        this._animationTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.TRAIN_BRAKE),durationLeft);
        this._animationTimeline.add(() => PunkGameModuleConfig.xWayCounter.trainState(TrainState.OPEN_CLOSE), durationLeft);
        this._animationTimeline.add(() => PunkGameModuleConfig.xWayCounter.showTrainItems(true, this.jumpWReelPos, 0.3), durationLeft +  TrainState.getDuration(TrainState.OPEN_CLOSE)-0.15);
        this._animationTimeline.to(this,0.15,{})
    }

    protected scatterBehaviour(reelID:number):void{
        const scatterPos:number = this._gameData!.scatterReelPositions[reelID];
        if(scatterPos == -1) return;

        let scatterSound:string = SoundConfig.instance.SCATTER_LAND;
        PunkEngineManager.getReel(reelID).getSymbol(scatterPos)!.changeState({
            state: ReelSymbolStates.ATTENTION,
            repeat: -1,
        });

        this.miniShake();
        SoundManager.playSoundEffect(scatterSound);
    }

    protected jumpTheWilds():void{
        PunkGameModuleConfig.xWayCounter.setTrainItems(this.featureWon);
        const startDelay:number = this._animationTimeline.totalTime();
        this._animationTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.WILD_MOVES),0);
        for(let r = 0; r < this.jwBefore;r++){
            this._animationTimeline.add([
                JumpingWildController.instance.JumpTo({
                ID:r,
                to:{ reel: this._jumpPositions[r].to.x, row: this._jumpPositions[r].to.y },
                duration: MathHelper.frameToSeconds(20),
                state: JumpWildState.WIN
            }),
            () => JumpingWildController.instance.changeMult(r, 1),
            ],startDelay)
        }
        this._animationTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.WILD_LOCKS), startDelay + MathHelper.frameToSeconds(20));
        this._animationTimeline.to(this, MathHelper.frameToSeconds(25),{});
    }
}